import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'

const AirwayRx = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={6}>
      <Autocomplete
        value={moduleValues?.['Pre Arrival Airway Management'] ?? []}
        options={[
          'Jaw Thrust',
          'Head Tilt',
          'Suctioning',
          'OPA/NPA',
          'iGel',
          'Intubation',
          'None'
        ]}
        multiple
        onChange={(e, value) => setModuleValues(prev => ({...prev, ['Pre Arrival Airway Management']: value}))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Pre-Arrival Airway Management"
          />
        )}
      />
    </Grid>

)

export default AirwayRx
